import React from "react";
import { Box, Typography } from "@material-ui/core";
import PropTypes from "prop-types";

const MoreInfo = props => {
  const { obs } = props;
  return (
    <Box my={2} mx={3}>
      <Typography variant="body1">{obs}</Typography>
    </Box>
  );
};

MoreInfo.propTypes = {
  obs: PropTypes.string.isRequired
};

export default MoreInfo;
